import React from 'react';
import { makeStyles } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import NonSupportedBrowserMessage from '../components/common/NonSupportedBrowserMessage';
import View from './views';

const useStyles = makeStyles(theme => ({
  container: {
    marginTop: theme.spacing(4)
  },
  imageContainer: {
    width: '400vh',
    height: '81vh',
    objectFit: 'contain'
    // [theme.breakpoints.up('lg')]: {
    //     imageContainer: {
    //     width: '400vh',
    //     height: '80vh',
    //     objectFit: 'contain'
    //     }
    // },
  }
}));

const StartPage = () => {
  const classes = useStyles();
  View.StartPage.visit();
  return (
    <>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        className={classes.container}
      >
        <NonSupportedBrowserMessage />
        <img className={classes.imageContainer} src="Welcome-new.png" alt="" />
      </Box>
    </>
  );
};

export default StartPage;
